import { render, staticRenderFns } from "./DocketEntryEditorWorkflow.vue?vue&type=template&id=3359107c&scoped=true&"
import script from "./DocketEntryEditorWorkflow.vue?vue&type=script&lang=js&"
export * from "./DocketEntryEditorWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./DocketEntryEditorWorkflow.vue?vue&type=style&index=0&id=3359107c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3359107c",
  null
  
)

export default component.exports